import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect } from "react";
import classNames from "classnames";
import { Button } from "../../components/Button";
import { FormField } from "../../components/Form/FormField";
import { OtpInput } from "../../components/OtpInput/OtpInput";
import { useCounters } from "../../hooks/useCounters/useCounters";
import { useTranslations } from "../../providers/useTranslations";
import { secondsToMs } from "../../utils/secondsToMs/secondsToMs";
import styles from "./EmailOtp.module.scss";
export const EmailOtp = ({ otpName, time, showBorder = true, onResendCode, onSubmit, autocompleteType = "off", isOtpNumeric = false, ...props }) => {
    const { __ } = useTranslations();
    const { remainingTime, resetTimer, startCounter } = useCounters(time);
    const borderClassNames = classNames(styles.border, props.className);
    const textClassNames = classNames(styles.text, props.classNameText);
    useEffect(() => {
        startCounter();
    }, []);
    const handleResendCode = useCallback((e) => {
        e.preventDefault();
        onResendCode();
        resetTimer();
    }, [onResendCode, resetTimer]);
    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            onSubmit?.();
        }
    };
    return (_jsxs("div", { className: borderClassNames, children: [showBorder && _jsx("div", { className: styles.text, children: __("auth.registration.login_credentials.email_verify.text") }), _jsx("div", { "data-testid": "email-otp-wrapper", onKeyDown: handleKeyDown, children: _jsx(FormField, { name: otpName, render: ({ field }) => (_jsx(OtpInput, { ...field, "data-testid": "otpInput", inputStyle: `${styles.inputStyle}`, autocompleteType: autocompleteType, isInputNum: isOtpNumeric })), validation: {
                        required: __("auth.registration.otp.validation.field_required"),
                        minLength: {
                            value: 4,
                            message: __("auth.registration.otp.validation.field_min_length"),
                        },
                    } }) }), _jsx("div", { className: textClassNames, children: remainingTime ? (_jsxs(_Fragment, { children: [_jsx("span", { children: __("auth.registration.otp.email.sent") }), _jsxs("div", { className: styles.timer, children: [__("auth.registration.login_credentials.email_verify.resend_text.request_another"), _jsx("span", { "data-testid": "otp-timeout-counter", children: secondsToMs(remainingTime) })] })] })) : (_jsxs(_Fragment, { children: [_jsx("span", { className: styles.requestNewCode, children: __("auth.registration.otp.request_new_code_text") }), _jsx(Button, { className: styles.resendBtn, "data-testid": "resendCode", color: "tertiary", onClick: handleResendCode, children: __("auth.registration.otp.request_new_code_code") })] })) })] }));
};
//# sourceMappingURL=EmailOtp.js.map